<template>
  <div>
    <div class="d-flex flex-wrap align-items-center">
      <b-badge
        v-for="pm in values"
        :key="pm.value"
        variant="info"
        class="pm-badge mr-1 mb-1 d-inline-flex align-items-center"
        :class="{ 'pm-badge--removing': removingId === pm.value }"
      >
        {{ pm.text }}
        <span
          v-if="removingId !== pm.value"
          class="ml-1"
          style="cursor: pointer; font-size: 1.1em; line-height: 1"
          :title="$t('settings.remove_project_manager')"
          @click="onRemove(pm.value)"
        >
          &times;
        </span>
        <b-spinner
          v-else
          small
          class="ml-1"
          style="width: 0.7em; height: 0.7em"
        />
      </b-badge>
      <b-badge
        v-if="addingName"
        variant="info"
        class="pm-badge pm-badge--adding mr-1 mb-1 d-inline-flex align-items-center"
      >
        {{ addingName }}
        <b-spinner small class="ml-1" style="width: 0.7em; height: 0.7em" />
      </b-badge>
    </div>
    <div v-if="!addingName && availableManagers.length > 0">
      <b-button
        v-if="!showSelect"
        size="sm"
        variant="outline-secondary"
        @click="showSelect = true"
      >
        {{ $t('settings.add_project_manager_add') }}
      </b-button>
      <b-form-select
        v-if="showSelect"
        size="sm"
        style="max-width: 200px"
        :value="null"
        @change="onAdd"
      >
        <template slot="first">
          <option :value="null" disabled>
            -- {{ $t('settings.add_project_manager_select') }} --
          </option>
        </template>
        <option
          v-for="pm in availableManagers"
          :key="pm.value"
          :value="pm.value"
        >
          {{ pm.text }}
        </option>
      </b-form-select>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    projectId: [Number, String],
    projectManagers: Array,
    values: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showSelect: false,
      addingName: null,
      removingId: null,
    };
  },
  computed: {
    assignedSfids() {
      return (this.values || []).map((v) => v.value);
    },
    availableManagers() {
      return (this.projectManagers || []).filter(
        (pm) => !this.assignedSfids.includes(pm.value),
      );
    },
  },
  watch: {
    values() {
      this.removingId = null;
      this.addingName = null;
    },
  },
  methods: {
    onAdd(sfid) {
      if (sfid) {
        const pm = (this.projectManagers || []).find((p) => p.value === sfid);
        this.addingName = pm ? pm.text : '...';
        this.showSelect = false;
        this.$emit('add', this.projectId, sfid);
      } else {
        this.showSelect = false;
      }
    },
    onRemove(sfid) {
      this.removingId = sfid;
      this.$emit('remove', this.projectId, sfid);
    },
  },
};
</script>
<style scoped>
.pm-badge {
  transition: opacity 0.2s ease;
}
.pm-badge--removing {
  opacity: 0.5;
}
.pm-badge--adding {
  opacity: 0.5;
}
</style>
